//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;

    if($(this).hasClass('-gnav')) {
      $('.p-gnav').removeClass('is-show');
    }

    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

$(function(){
  const $menu = $('.p-hd__menu a');

  if($menu[0]) {
    const $nav = $('.p-gnav');
    const $close = $('.p-gnav__close a');

    $menu.on('click', function(event) {
      $nav.addClass('is-show');
    });

    $close.on('click', function(event) {
      $nav.removeClass('is-show');
    });
  }
});

$(function(){
  const $btns = $('.p-ft__btns');

  if($btns[0]) {
    $(window).on('scroll', function(event) {
      run();
    });
    run();

    function run() {
      if($(window).scrollTop() > 50) {
        $btns.addClass('is-show');
      } else {
        $btns.removeClass('is-show');
      }
    }
  }
});

$.ajax({
type: 'GET',
url: 'https://graph.facebook.com/v12.0/17841449909561942?fields=name%2Cmedia.limit(4)%7Bcaption%2Clike_count%2Cmedia_url%2Cpermalink%2Ctimestamp%2Cusername%7D&access_token=EAADuZA6IlL6QBAAFRSY73y0BUuQwVUedEWLFwQ15dKuJWG2xlSU2AHwEUgGXHoxDs3c8gs8FSnRvZCyvMRVCGcE7EKGAD39xord1o8w4kEiyVtZAL51lcMeEaVMa1bwmjIbnC2gdYZAVp1MuL9EYOl7ZAGYkPwppZChbd4emhq8ylFXcXXZCnqn',
dataType: 'json',
 success: function(json) {
var ig = json.media.data;
var html = "";
for (var i = 0; i < ig.length; i++) {
var link = ig[i].permalink;
var image
if(!ig[i].thumbnail_url) {
// 動画の場合はこちら
image = ig[i].media_url;}
else {
// 写真の場合はこちら
image = ig[i].thumbnail_url;
}
html += '<li><a class="u-over" href="' + link + '" target="_blank"><img src="' + image + '"></a></li>'
}
$(".js-igfeed").append(html);
}
});
